var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState, useMemo } from 'react';
import { Icon, Image, Form } from 'semantic-ui-react';
import { CommentsList, PostCommentWidget } from './Comments';
import './Place.css';
import './commonStyles.css';
import cx from 'classnames';
import CloudinaryImageUpload from './CloudinaryImageUpload';
import { LikeWidget } from './LikeWidget';
var _a = process.env, REACT_APP_CLOUDINARY_CLOUD_NAME = _a.REACT_APP_CLOUDINARY_CLOUD_NAME, REACT_APP_CLOUDINARY_UPLOAD_PRESET_LOGO = _a.REACT_APP_CLOUDINARY_UPLOAD_PRESET_LOGO;
var reHttp = /^https?:\/\//;
// www.dd.com -> https://www.dd.com
var normalizeUrl = function (url) {
    return reHttp.test(url) ? url : "https://" + url;
};
export var Place = function (_a) {
    var item = _a.item, user = _a.user, expanded = _a.expanded, onClick = _a.onClick, onVote = _a.onVote, onComment = _a.onComment;
    var title = item.title, description = item.description, logoURL = item.logoURL, short_description = item.short_description, url = item.url, userVoted = item.userVoted, votes = item.votesCount, comments = item.comments;
    var commentsCount = (comments === null || comments === void 0 ? void 0 : comments.length) || 0;
    var sortedComments = useMemo(function () {
        if (!comments)
            return comments;
        return comments.sort(function (l, r) { return (l.created < r.created ? -1 : 1); });
    }, [comments]);
    var icon = 'building outline';
    return (React.createElement("div", { className: cx({ item: true, 'place-item': true, expanded: expanded }), onClick: onClick },
        React.createElement("div", { className: "title" },
            logoURL ? React.createElement(Image, { src: logoURL }) : React.createElement(Icon, { name: icon }),
            title),
        !!short_description && (React.createElement("section", { className: "short-description" }, short_description)),
        expanded && !!url && (React.createElement("p", { className: "external-url" },
            React.createElement("a", { href: normalizeUrl(url), title: url },
                React.createElement(Icon, { name: "external" }),
                " ",
                url))),
        expanded && description !== title && (React.createElement("section", { className: "description" }, description)),
        !!commentsCount && (React.createElement("div", { className: "replies-count" },
            commentsCount,
            " comments")),
        expanded && (React.createElement("section", null,
            React.createElement(LikeWidget, { votes: votes, userVoted: userVoted, onVote: onVote }))),
        expanded && !!commentsCount && (React.createElement("section", null,
            React.createElement("h4", { className: "pale-heading" }, "Replies"),
            React.createElement(CommentsList, { comments: sortedComments }))),
        expanded &&
            (!!user ? (React.createElement(PostCommentWidget, { onComment: onComment })) : (React.createElement("div", { style: { textAlign: 'center' } }, "You need to register or sign in to be able to post")))));
};
export var AddNewPlaceObject = function (_a) {
    var type = _a.type, onPost = _a.onPost;
    var _b = useState({}), state = _b[0], setState = _b[1];
    var onChange = function (e) {
        var _a;
        var _b = e.target, name = _b.name, value = _b.value;
        console.debug(e.target.name, e.target.value);
        setState(__assign(__assign({}, state), (_a = {}, _a[name] = value, _a)));
    };
    return (React.createElement("div", { className: "add-new-place" },
        React.createElement("h4", null,
            React.createElement(Icon, { name: "building outline" }),
            " New place"),
        React.createElement(Form, { onSubmit: function (e) {
                e.preventDefault();
                console.debug('submit', state);
                var placeName = state.placeName, description = state.description, _a = state.short_description, short_description = _a === void 0 ? null : _a, _b = state.url, url = _b === void 0 ? null : _b, _c = state.logoURL, logoURL = _c === void 0 ? null : _c;
                onPost({
                    type: type,
                    title: placeName,
                    description: description,
                    short_description: short_description,
                    url: url,
                    logoURL: logoURL,
                    valid_until: '2100-01-05T09:00:00.000Z',
                });
            } },
            REACT_APP_CLOUDINARY_CLOUD_NAME && (React.createElement(Form.Field, null,
                React.createElement("label", null, "Logo"),
                React.createElement(CloudinaryImageUpload, { cloudName: REACT_APP_CLOUDINARY_CLOUD_NAME, uploadPreset: REACT_APP_CLOUDINARY_UPLOAD_PRESET_LOGO, onChange: function (logoURL) { return setState(__assign(__assign({}, state), { logoURL: logoURL })); } }, state.logoURL && React.createElement(Image, { src: state.logoURL, alt: "logo" })))),
            React.createElement(Form.Input, { autoComplete: "off", label: "Name", placeholder: "e.g. Annie's Bakery", name: "placeName", required: true, onChange: onChange }),
            React.createElement(Form.Input, { autoComplete: "off", label: "Very brief description", name: "short_description", placeholder: "e.g. Nice bagels and tasty latte", required: true, onChange: onChange }),
            React.createElement(Form.Input, { autoComplete: "off", label: "Website URL", name: "url", onChange: onChange }),
            React.createElement(Form.TextArea, { autoFocus: true, required: true, label: "Description", name: "description", onChange: onChange }),
            React.createElement(Form.Button, { primary: true }, "Add"))));
};
//# sourceMappingURL=Place.js.map